import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Input, Paper, Step, StepContent, StepLabel, Stepper, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CropFreeIcon from '@material-ui/icons/CropFree';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import BarkodPopup from './BarcodePopup';

const useStyles = makeStyles((theme) => ({
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButtonWudaq: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    width: '50%'
  }
}));


function PowerMeasure(props) {

  const classes = useStyles();

  const [loading, setLoading] = useState(false);

  const [OpenBarkodCihaz, setOpenBarkodCihaz] = React.useState(false);
  const [CihazBarcode, setCihazBarcode] = React.useState("");

  const [response, setResponse] = useState("");

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ["Ürün Bilgileri", "Cihaz İşlemleri"];

  const handleNext = () => {
    if (activeStep !== steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      return;
    }
    let data = loadBaslandiJob()[0];
    let user = getUser();
 
    setLoading(true);
    axios.get('/GetDoraPowerMeasure/' + data.FisNo + '/' + (user.UserId || 'a') + '/' + (CihazBarcode || 'a') + '/' + (data?.KUL_MODEL_KODU || 'a') + '/' + (data?.BARKOD || 'a'))
    .then(res => {
        setResponse(res.data.message);
        setLoading(false);
        setActiveStep(steps.length);
      })
  };




  function getStepContent(step) {
    switch (step) {
      case 0:
        let data = loadBaslandiJob();
        if (data?.length === 0)
          return <div></div>;

        return <div>
          <Typography className={classes.title} color="textSecondary">
            {"Barkod"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.BARKOD || ''}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {"Model Kodu"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.KUL_MODEL_KODU || ''}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {"Model"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.MODEL || ''}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {"Üretim Yılı"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.UYIL || ''}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {"Üretim Dönemi"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.UDONEM || ''}
          </Typography>
          <Typography className={classes.title} color="textSecondary">
            {"Seri Numarası"}
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            {data[0]?.SERINO || ''}
          </Typography>
        </div>;
      case 1:
        return <div className={classes.fields}>
          <Paper
            className={classes.search}
            elevation={1}>
            <CropFreeIcon
              onClick={() => setOpenBarkodCihaz(true)}
              className={classes.searchIcon} />
            <Input
              className={classes.searchInput}
              disableUnderline
              value={CihazBarcode}
              onChange={event => { setCihazBarcode(event.target.value) }}
              placeholder={"Cihaz Barkodunu Okutunuz!..."}
            />
          </Paper>
        </div>;
      default:
        return "";
    }
  }

  const handleCihazBarkodClose = async (barkod) => {
    setCihazBarcode(barkod);
    setOpenBarkodCihaz(false);
  }
  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => props.setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen>
        <DialogTitle id="alert-dialog-title">
          DORA Güç Ölçüm İşlemi
          <Divider />
        </DialogTitle>

        <DialogContent>
          {loading && <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />}
          <Stepper activeStep={activeStep}
            orientation="vertical">
            {steps?.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <br />
                  <br />
                  {getStepContent(index)}
                  <br />
                  <br />
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0 || loading}
                        variant="contained"
                        style={{ backgroundColor: '#FF9800', color: '#424242' }}
                        onClick={() => setActiveStep((prev) => prev - 1)}
                        startIcon={<KeyboardArrowLeft />}
                        className={classes.button}
                      >
                        Gerİ
                      </Button>

                      <Button
                        disabled={loading}
                        variant="contained"
                        color="secondary"
                        onClick={handleNext}
                        endIcon={<KeyboardArrowRight />}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "GüçÖlçümTalebi" : "İlerİ"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>{response}</Typography>
              <Button onClick={() => setActiveStep(0)} className={classes.button}>
                Başa Dön
          </Button>
            </Paper>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => props.setOpen(false)}
            className={classes.submitButtonWudaq}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>

        </DialogActions>
      </Dialog>
      <BarkodPopup onClose={handleCihazBarkodClose} open={OpenBarkodCihaz} ScanTime={0} CallScreen={0} />
    </>
  );
}

export default PowerMeasure;
